
import { useNavigate } from 'react-router-dom';

import { Menubar } from 'primereact/menubar';

export default function Menubar1(){

    const navigate = useNavigate();

    const menuItems = [
        {
            label: '首頁',
            icon: 'pi pi-home',
            command: () => navigate('/home')
        },
        {
            label: '修改',
            icon: 'pi pi-file-edit',
            //command: () => navigate('/assignall'),
            items: [
                {
                    label: '修改 - 服事人員',
                    icon: 'pi pi-user-edit',
                    command: () => navigate('/memberList'),
                },                
                {
                    label: '修改 - 服事名單',
                    icon: 'pi pi-users',
                    command: () => navigate('/assignall'),
                },
                {
                    label: '修改 - 服事項',
                    icon: 'pi pi-list'
                },                
            ]            
        },
        {
            label: '測試',
            icon: 'pi pi-box',
            command: () => navigate('/test')
        },
        {
            label: '登出',
            icon: 'pi pi-sign-out',
            command: () => navigate('/signout')
        }
    ];

    return (
        <div>
            <Menubar model={menuItems} style={{ backgroundColor: 'lightBlue' }}/>
            <div><br/></div>
        </div>
    )

}